import request from '@/utils/axios'
import qs from 'qs'

/**
 * 根据用户名获取会员课包列表
 * @param {*} username 
 * @param {*} params 
 */
export function getCoursePackageAndMemberListByUsername(username) {
    return request({
        url: '/api/manager/coursepackageandmember/' + username,
        method: 'get',
    })
}

/**
 * 添加会员对应的课包记录
 * @param {*} params 
 */
export function addCoursePackageAndMember(params) {
    let postData = qs.stringify(params)
    return request({
        url: 'api/manager/coursepackageandmember',
        method: 'post',
        data: postData
    })
}

/**
 * 修改课时账单
 * @param {*} params 
 */
export function editCoursePackageAndMember(params) {
    let postData = qs.stringify(params)
    return request({
        url: 'api/manager/coursepackageandmember',
        method: 'put',
        data: postData
    })
}

/**
 * 删除课包与会员的关联记录
 * @param {*} id 
 */
export function deleteCoursePackageAndMember(id) {
    return request({
        url: 'api/manager/coursepackageandmember/' + id,
        method: 'delete',
    })
}

/**
 * 根据课包id获取会员课包列表
 * @param {*} params 
 */
export function getCoursePackageAndMemberByCoursePackageId(params) {
    let postData = qs.stringify(params)
    return request({
        url: 'api/manager/coursepackageandmember/getCoursePackageAndMemberByCoursePackageId',
        method: 'post',
        data: postData
    })
}
// export function getCoursePackageAndMemberByCoursePackageId(params) {
//     return request({
//         url: 'api/manager/coursepackageandmember/getCoursePackageAndMemberByCoursePackageId',
//         method: 'get',
//         params: params
//     })
// }

/**
 * 根据课包id获取会员课包列表
 * @param {*} params 
 */
export function getCoursePackageAndMemberByCoursePackageIdAndTelephone(params) {
    let postData = qs.stringify(params)
    return request({
        url: 'api/manager/coursepackageandmember/getCoursePackageAndMemberByCoursePackageIdAndTelephone',
        method: 'post',
        data: postData
    })
}
//课包延期
export function changeMemberCoursePackageClasshourDDLById(params) {
    let postData = qs.stringify(params)
    return request({
        url: '/api/manager/coursepackageandmember/changeMemberCoursePackageClasshourDDLById',
        method: 'post',
        data: postData
    })
}
//一键课包延期
export function changeMemberCoursePackageClasshourDDL(params) {
    let postData = qs.stringify(params)
    return request({
        url: '/api/manager/coursepackageandmember/changeMemberCoursePackageClasshourDDL',
        method: 'post',
        data: postData
    })
}
//完结课包
export function doneMemberCoursePackage(params) {
    let postData = qs.stringify(params)
    return request({
        url: '/api/manager/coursepackageandmember/doneMemberCoursePackage',
        method: 'post',
        data: postData
    })
}
//未完结课包
export function unDoneMemberCoursePackage(params) {
    let postData = qs.stringify(params)
    return request({
        url: '/api/manager/coursepackageandmember/unDoneMemberCoursePackage',
        method: 'post',
        data: postData
    })
}